import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ShippingRate } from '../../../common/model/dto/shipping-rate/shipping-rate';
import { useListNavigationState } from '../../../hooks/use-list-navigation-state';
import { useShippingRateListColumns } from '../../../hooks/use-shipping-rate-list-columns';
import OvRecordList from './OvRecordList';

interface OvShippingRateListProps {
  shippingRates: ShippingRate[];
}

const OvShippingRateList: FC<OvShippingRateListProps> = ({ shippingRates }) => {
  const { t } = useTranslation();
  const getNavigationState = useListNavigationState();
  const columns = useShippingRateListColumns(getNavigationState);

  return (
    <OvRecordList
      label={t('app.subPages.menu.shippingRates')}
      records={shippingRates}
      columns={columns}
      getKey={(record) => record.id}
      getDetailsPath={(record) => `/shipping-rates/${record.id}`}
      getNavigationState={getNavigationState}
    />
  );
};

export default OvShippingRateList;
